import axios from "axios"
import objectToFormData from "../utils/objectToFormData"
import { API } from "../constants"
import { apiUrl } from "./lt-api"

axios.defaults.baseURL = API

const defaultHeaders = {
  method: "get",
  crossDomain: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    withCredentials: true
  }
}

const getConfigWithToken = (method = "GET", extraConfig = {}) => {
  const token = JSON.parse(localStorage.getItem("token"))
  return {
    ...defaultHeaders,
    method,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
      ...extraConfig.headers
    },
    ...extraConfig
  }
}


export function getTagData(id) {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}tags/${id}`
  })
}

export function updateTagData(id, payload) {
  const formData = objectToFormData(payload)
  return axios({
    ...getConfigWithToken("PUT"),
    url: `${apiUrl}tags/${id}`,
    data: formData
  })
}

export function createTagData(payload) {
  const formData = objectToFormData(payload)
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}tags`,
    data: formData
  })
}

